import { useState, useEffect } from 'react'

export default function useUserLocation() {
  const [data, setData] = useState({
    ip: null,
    lat: null,
    lon: null,
    loading: true,
    error: null
  })

  const getLocation = async () => {
    const fetchIP = async () => {
      try {
        const res = await fetch('https://api.ipify.org?format=json')
        const { ip } = await res.json()
        return ip
      } catch {
        return null
      }
    }

    // 🔸 Commented out for now — no IP-based geo lookup
    /*
    const fetchGeoFromIP = async (ipAddr) => {
      try {
        const url = ipAddr
          ? `https://ipapi.co/${ipAddr}/json/`
          : `https://ipapi.co/json/`
        const res = await fetch(url)
        const data = await res.json()
        return { lat: data.latitude || null, lon: data.longitude || null }
      } catch {
        return { lat: null, lon: null }
      }
    }
    */

    const getBrowserGeo = () =>
      new Promise((resolve, reject) => {
        if (!navigator.geolocation)
          return reject('Geolocation not supported')

        // ✅ Explicitly ask for permission using Permissions API (if available)
        if (navigator.permissions) {
          navigator.permissions
            .query({ name: 'geolocation' })
            .then((result) => {
              if (result.state === 'denied') {
                // Permission already denied
                reject('Permission denied by user')
              } else {
                // Ask user to allow location
                navigator.geolocation.getCurrentPosition(
                  (pos) => {
                    const coords = {
                      lat: pos.coords.latitude,
                      lon: pos.coords.longitude
                    }
                    // console.log('Browser geolocation success:', coords)
                    resolve(coords)
                  },
                  (err) => {
                    reject(err.message || 'Permission denied')
                  },
                  { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
                )
              }
            })
            .catch(() => {
              // Fallback: directly try geolocation if Permissions API unavailable
              navigator.geolocation.getCurrentPosition(
                (pos) => {
                  const coords = {
                    lat: pos.coords.latitude,
                    lon: pos.coords.longitude
                  }
                  resolve(coords)
                },
                (err) => reject(err.message || 'Permission denied'),
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
              )
            })
        } else {
          // Fallback if Permissions API not supported (older browsers)
          navigator.geolocation.getCurrentPosition(
            (pos) => {
              const coords = {
                lat: pos.coords.latitude,
                lon: pos.coords.longitude
              }
              resolve(coords)
            },
            (err) => reject(err.message || 'Permission denied'),
            { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
          )
        }
      })

    try {
      const ip = await fetchIP()
      let location = { lat: null, lon: null }

      try {
        location = await getBrowserGeo()
      } catch (geoErr) {
        console.warn('Geolocation error:', geoErr)
        // ❗ User denied → null coordinates
        location = { lat: null, lon: null }
      }

      const result = { ip, lat: location.lat, lon: location.lon }
      setData({ ...result, loading: false, error: null })
      // console.log('result',result)
      return result
    } catch (err) {
      setData((p) => ({ ...p, loading: false, error: err.message }))
      return null
    }
  }

  useEffect(() => {
    getLocation()
  }, [])

  return { ...data, refetchLocation: getLocation }
}